/** Fixed colour for team-wide override segments so they stand out from per-user roster colours. */
export const OVERRIDE_SEGMENT_COLOR = '#d97706';

export function isOverrideSource(source: string | undefined): boolean {
  return String(source || '').toLowerCase() === 'override';
}

/** Diagonal stripes mark segments that differ from the roster (covers/overrides). */
export function timelineSourceBackground(source: string | undefined, color: string): string {
  const kind = String(source || '').toLowerCase();
  if (kind === 'cover') {
    return `repeating-linear-gradient(135deg, ${color} 0 8px, rgba(0,0,0,0.28) 8px 12px)`;
  }
  if (kind === 'override') {
    return `repeating-linear-gradient(45deg, ${OVERRIDE_SEGMENT_COLOR} 0 10px, rgba(0,0,0,0.35) 10px 14px)`;
  }
  return color;
}

export function timelineSourceBorder(source: string | undefined): string {
  const kind = String(source || '').toLowerCase();
  if (kind === 'cover') return '2px dashed rgba(255,255,255,0.85)';
  if (kind === 'override') return '2px solid #fbbf24';
  return '1px solid rgba(255,255,255,0.25)';
}
